<template>
  <div>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        msg: 1
      }
    },
    created() {
      this.$http
        .post("/mapi/user/check_login_app", {
          user_id: this.$route.query.uid,
          st: this.$route.query.st,
        })
        .then((res) => {
          //设置登录
          window.localStorage.setItem('user_info', JSON.stringify(res.data.data))
          window.location = this.$route.query.call_back_url
          console.log("已经登陆后台");
        });
    }
  }

</script>
